var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-base-notification-approve" },
    [
      _c("BaseNotificationTitle", {
        attrs: {
          code: _vm.code,
          platform: _vm.platform,
          dateTime: _vm.dateTime,
          queueNumber: _vm.queueNumber,
          tableNumber: _vm.tableNumber,
          orderDetail: _vm.orderDetail,
          responseStatus: _vm.responseStatus
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "action" }, [
        _c("div", { staticClass: "buttons" }, [
          _vm.responseStatus && !["", "unknown"].includes(_vm.queueNumber)
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light btn-sm",
                    on: { click: _vm.handleClickViewOrderNo }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("apps.pos.message.queuenumber", {
                            number: _vm.queueNumber
                          })
                        ) +
                        "\n        "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.responseStatus
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger btn-sm",
                    on: { click: _vm.handleClickReject }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("button.reject")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web btn-sm",
                    on: { click: _vm.handleClickApprove }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("button.approve")) +
                        "\n        "
                    )
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "icon", style: [{ opacity: !_vm.isRead ? 1 : 0 }] },
          [_c("i", { staticClass: "fas fa-circle" })]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8da97b20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8da97b20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseNotificationItemApprove.vue
// module id = null
// module chunks = 